export default __webpack_public_path__ + "static/impact-footer-0d7ce159423bec01ec8b986dc71fe1d7.jpg";